"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnonymousSubscriptionBanner = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Displays box for anonymous user with information about autosubscription.
 * It is visible if at least title or message or ReadMe link have correct data.
 */
const AnonymousSubscriptionBanner = ({
  className,
  message,
  readMoreLink,
  readMoreText,
  title
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.ANONYMOUS_SUBSCRIPTION_BANNER),
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h6",
      component: "p",
      "data-testid": getTestId(_constants.ANONYMOUS_SUBSCRIPTION_BANNER_TITLE),
      children: title
    }) : null, message != null && message !== '' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      "data-testid": getTestId(_constants.ANONYMOUS_SUBSCRIPTION_BANNER_MESSAGE),
      component: "div",
      children: message
    }) : null, readMoreLink && readMoreText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
      "data-testid": getTestId(_constants.ANONYMOUS_SUBSCRIPTION_BANNER_READ_MORE),
      color: "textPrimary",
      fontWeight: "bold",
      href: readMoreLink,
      children: readMoreText
    }) : null]
  });
};
exports.AnonymousSubscriptionBanner = AnonymousSubscriptionBanner;
//# sourceMappingURL=AnonymousSubscriptionBanner.js.map